<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        v-if="
      resource.idEstatusSolicitud === 1 ||
      resource.idEstatusSolicitud === 2
    "
        :to="{
      name: 'CotizacionCajaPti',
      params: {
        idPti: data.item.idPti,
        idRecibo: data.item.idRecibo,
        idSesion: data.item.idSesion,
        idSolicitud: data.item.idSolicitudDiagnostico,
        idTipoSolicitud: data.item.idTipoSolicitud,
      },
    }"
    >
      <p
          @click="putCambiarEstatusSolicitud(data.item.idSolicitudBandejaCobro, resource.idEstatusSolicitud)"
          class="letraColorAzulPrincipal letraEstiloNegrita">
        {{ data.item.nombrePaciente }}
      </p>

    </router-link>
    <router-link
        v-else
        :to="{
      name: 'paciente',
      params: { id: data.item.idPaciente },
    }"
    >
      <p class="letraColorAzulPrincipal letraEstiloNegrita">
        {{ data.item.nombrePaciente }}
      </p>
    </router-link>
  </div>

</template>

<script>
export default {
  name: "BandejaLinkPacienteCobroComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: { 
        
    putCambiarEstatusSolicitud(idSolicitudBandejaCobro, estatus) {
      if(estatus == 1){
        var params = {
          idSolicitudDiagnostico: idSolicitudBandejaCobro,
          idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
          idEstatus: 2,
        };

        this.$http
          .put(
            this.$api +
              "pti/bandeja/cobro/cambiarEstatusSolicitud",
            params
          )
          .then((response) => {
            return response;
          })
          .catch((error) => {
            console.error(error);
          });
      }

    },
    
    
  },
};
</script>
